import { Flex, FlexBlock, DropdownMenu, Icon, __experimentalToggleGroupControl, __experimentalToggleGroupControlOption } from '@wordpress/components';
import { desktop, tablet, mobile } from '@wordpress/icons';
import { useSelect } from '@wordpress/data';
import './label-unit.css';
const { useState, useEffect } = wp.element;
import { setAttributesResponsive, getValueByPath } from '../../block/functions.js';

const LabelUnit = ({ attributes, setAttributes, label, unit = 'px', attributeName }) => { // Đang ở đây, mới thêm 2 thuộc tính attributes và setAttributes
    const currentDevice = useSelect((select) => {
        return select('core/edit-post').__experimentalGetPreviewDeviceType();
    }, []);
    const device = currentDevice.toLowerCase();
    const deviceString = device === 'desktop' ? '' : `:${device}`;
    const pathValue = attributeName.split('.')[0] + deviceString + '.' + attributeName.split('.').slice(1).join('.');

    const handleChangeUnit = (newValue) => {
        setAttributesResponsive(attributeName, newValue, device, setAttributes, attributes);
    }

    return (
        <>
            <Flex justify="flex-start">
                <FlexBlock>
                    <label style={{ marginRight: '5px' }}>{label}</label>
                </FlexBlock>
                <FlexBlock>
                    <__experimentalToggleGroupControl
                        __nextHasNoMarginBottom
                        isBlock
                        className="softlite-toggle-unit-options"
                        onChange={(newValue) => handleChangeUnit(newValue)}
                        value={getValueByPath(pathValue, attributes) ? getValueByPath(pathValue, attributes) : 'px'} // Đang ở đây, cần lưu lại uit trên các thiết bị, truyền tham số attributes để hàm change lưu lại
                    >
                        <__experimentalToggleGroupControlOption
                            label="PX"
                            value="px"
                            className='softlite-toggle-unit'
                        />
                        <__experimentalToggleGroupControlOption
                            label="%"
                            value="%"
                            className='softlite-toggle-unit'
                        />
                        <__experimentalToggleGroupControlOption
                            label="EM"
                            value="em"
                            className='softlite-toggle-unit'
                        />
                        <__experimentalToggleGroupControlOption
                            label="REM"
                            value="rem"
                            className='softlite-toggle-unit'
                        />
                        <__experimentalToggleGroupControlOption
                            label="VW"
                            value="vw"
                            className='softlite-toggle-unit'
                        />
                        <__experimentalToggleGroupControlOption
                            label="VH"
                            value="vh"
                            className='softlite-toggle-unit'
                        />
                    </__experimentalToggleGroupControl>
                </FlexBlock>
            </Flex>
        </>
    );
}
export default LabelUnit;